import LogoDelend from "./LogoDelend";
import LogoRedeOkayVersion2 from "./LogoRedeOkayVersion2";

const BrandLogo = () => {
  const path = window.location.href;
  if (path.includes(".ok.")) {
    return <LogoRedeOkayVersion2 />;
  }
  return <LogoDelend />;
};

export default BrandLogo;
